import { ThemeProvider, createTheme } from "@mui/material/styles";
import { themeOptions } from "./theme/theme";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/common/layout/layout";
import Home from "./components/home/home";
import NoMatch from "./components/no-match/no-match";
import Info from "./components/info/info";
import LineUp from "./components/line-up/line-up";
import MapAndVenues from "./components/map-and-venues/map-and-venues";
// import StewartLee from "./components/stewart-lee/stewart-lee";
// import StageTimes from "./components/stage-times/stage-times";

import "./App.css";

import "./fonts/itc-busorama-bold.otf";
import LandingLayout from "./components/common/layout/landing-layout";
import HomeLanding from "./components/home/home-landing";

function App() {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <CssBaseline />
        <Routes>
          <Route path="/" element={<LandingLayout />}>
            <Route index element={<HomeLanding />} />
          </Route>
          <Route path="/2026" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="line-up" element={<LineUp />} />
            <Route path="info" element={<Info />} />
            {/* <Route path="stewart-lee" element={<StewartLee />} />
            <Route path="stage-times" element={<StageTimes />} />
            <Route path="competition" element={<Competition />} /> */}
            <Route path="map-and-venues" element={<MapAndVenues />} />
            <Route path="*" element={<NoMatch />} /> 
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
